import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { StoredMessage } from '../storage/db'

/**
 * Composer mode: editing a message in a conversation, from its box or, for a reply, from its
 * thread's box (`thread`: the thread's top-level message).
 */
export const useComposer = defineStore('composer', () => {
  const mode = ref<{ conv: string; thread?: string; kind: 'edit'; target: StoredMessage; draft?: string } | null>(null)

  function edit(conv: string, target: StoredMessage, current: string, thread?: string): void {
    mode.value = { conv, thread, kind: 'edit', target, draft: current }
  }

  function clear(): void {
    mode.value = null
  }

  return { mode, edit, clear }
})
